import React, { useEffect, useState } from "react";
import { CustomInput } from "../../../../components";

function ViewUser(props) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [roleName, setRoleName] = useState("");
  const [groupName, setGroupName] = useState("");

  useEffect(() => {
    setFirstName(props.users.first_name || "");
    setLastName(props.users.last_name || "");
    setEmail(props.users.email || "");
    setRoleName(props.users.role_name || "");
    setGroupName(props.users.group_name || "");
  }, [props?.users]);

  const handleCloseViewUser = (e) => {
    e.preventDefault();

    props.setUsers({
      id: 0,
      first_name: "",
      last_name: "",
      email: "",
      role_id: "",
      role_name: "",
      group_name: "",
    });
  };

  return (
    <div
      className="offcanvas offcanvas-end Add-Recipients"
      data-bs-scroll="true"
      tabIndex={-1}
      data-bs-keyboard="false"
      data-bs-backdrop="static"
      id="viewUser"
      aria-labelledby="viewUserLabel"
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title" id="viewUserLabel">
          View User
        </h5>

        <button
          type="button"
          className="btn close_btn text-reset"
          data-bs-dismiss="offcanvas"
          onClick={handleCloseViewUser}
          aria-label="Close"
        >
          <i className="bi bi-x-circle" aria-hidden="true" />
        </button>
      </div>

      <div className="offcanvas-body px-0">
        <div className="row mx-lg-2">
          <div className="col-lg-6 mb-3">
            <CustomInput
              label="First Name"
              value={firstName}
              name="first_name"
              disabled={true}
            />
          </div>

          <div className="col-lg-6 mb-3">
            <CustomInput
              label="Last Name"
              value={lastName}
              name="last_name"
              disabled={true}
            />
          </div>

          <div className="col-lg-6 mb-3">
            <CustomInput
              label="Email"
              value={email}
              name="email"
              disabled={true}
            />
          </div>

          <div className="col-lg-6 mb-3">
            <CustomInput
              label="Role Name"
              value={roleName}
              name="role_name"
              disabled={true}
            />
          </div>

          <div className="col-lg-12 mb-3">
            <CustomInput
              label="Group Name"
              value={groupName}
              name="group_name"
              disabled={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewUser;
